import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDbONvvd33odfx0ShNC1xnURZVztkqQAa8",
  authDomain: "nutrius-production.firebaseapp.com",
  projectId: "nutrius-production",
  storageBucket: "nutrius-production.firebasestorage.app",
  messagingSenderId: "522477846195",
  appId: "1:522477846195:web:562a3d296bc87795bdbac6",
  measurementId: "G-1FC0D9X5G8"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;